module.exports = __webpack_public_path__ + "img/sys_name_new.e3cf3394.png";